import {AfterViewInit, Component, ElementRef, HostListener, Inject, OnInit, ViewChild} from '@angular/core';
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";

@Component({
    selector: 'app-cart-delete-dialog',
    templateUrl: './cart-delete-dialog.component.html',
    styleUrl: './cart-delete-dialog.component.scss',
    standalone: false
})
export class CartDeleteDialogComponent implements OnInit, AfterViewInit{
  deleteCartForm!: FormGroup;
  @ViewChild('deleteReasonInput') deleteReasonInput!: ElementRef;

  constructor(@Inject(MAT_DIALOG_DATA) public data: string,
    public dialogRef: MatDialogRef<CartDeleteDialogComponent>
  ) {
  }

  @HostListener('document:keydown', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent) {
    // Enter - Submit delete (only when form is valid)
    if (event.key === 'Enter') {
      if (this.deleteCartForm && this.deleteCartForm.valid) {
        event.preventDefault();
        this.onDelete();
      }
      return;
    }

    // Escape - Cancel
    if (event.key === 'Escape') {
      event.preventDefault();
      this.dialogRef.close(true);
      return;
    }
  }

  ngOnInit() {
    this.deleteCartForm = new FormGroup({
      deleteReason: new FormControl(null, Validators.required)
    });
  }

  ngAfterViewInit() {
    // Auto-focus the delete reason input when dialog opens
    setTimeout(() => {
      this.deleteReasonInput?.nativeElement?.focus();
    }, 100);
  }

  onDelete() {
    if (this.deleteCartForm.valid) {
      this.dialogRef.close(this.deleteCartForm.get('deleteReason')?.value);
    } else {
      Object.values(this.deleteCartForm.controls).forEach(control => {
        if (control.invalid) {
          control.markAsDirty();
          control.updateValueAndValidity({ onlySelf: true })
        }
      })
    }
  }
}
